module.exports = __webpack_public_path__ + "img/goodbye-arezra.386090ca.jpg";